import {CloseOutlined, DownOutlined} from "@ant-design/icons";
import {Button, Checkbox, Input, List, Modal, Radio, Row, Switch, Tree} from "antd";
import {useEffect, useState} from "react";
import i18next from "i18next";
import * as OrganizationBackend from "../../services/OrganizationBackend";
import * as Setting from "../../conf/Setting";
import * as IconFont from "../common/IconFont";
import "../../assets/styles/user/UserTransfer.less";

export const UserExportModal = (props) => {
  const {visible, dismiss, confirmLoading, onConfirmSelect, organId, isOrgSelectDisabled} = props;
  const [treeData, setTreeData] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [transferedNodes, setTransferedNodes] = useState([]);
  const [titleNodeName, setTitleNodeName] = useState("user-transfer-tree-node-title");
  const [keyword, setKeyword] = useState("");
  const [searchList, setSearchList] = useState([]);
  const [exportType, setExportType] = useState(2);
  const [enableDirectExport, setEnableDirectExport] = useState(false);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(entries => {
      if (document.getElementsByClassName("user-transfer-tree").length > 0) {
        const width = document.getElementsByClassName("user-transfer-tree")[0].clientWidth;
        if (width !== 293) {
          setTitleNodeName("user-transfer-tree-node-title-resize");
        } else {
          setTitleNodeName("user-transfer-tree-node-title");
        }
      }
    });
    if (document.getElementsByClassName("user-transfer-tree").length > 0) {
      resizeObserver.observe(document.getElementsByClassName("user-transfer-tree")[0]);
    }
    return (() => {
      // 在不需要监听的时候或离开界面的时候销毁
      resizeObserver.disconnect();
    });
  });

  useEffect(() => {
    setTreeData([]);
    setExpandedKeys([]);
    setCheckedKeys([]);
    setTransferedNodes([]);
    if (visible) {
      fetchTreeData();
    }
  }, [visible]);

  const fetchTreeData = (params = {}) => {
    OrganizationBackend.getOrganization(Setting.Admin, organId)
      .then((res) => {
        if (res.msg === undefined) {
          const treeList = [res];
          const filterList = treeList.map(item => {
            item.isOrganization = true;
            item.level = 0;
            item.icon = <IconFont.OrganizationIcon style={{fontSize: 16}} />;
            item.isLeaf = item.childNum === 0;
            item.disabled = isOrgSelectDisabled ? isOrgSelectDisabled : false;
            return item;
          });
          setExpandedKeys([filterList[0].uid]);
          setTreeData(filterList);
        } else {
          Setting.showResponseMessage(res.msg);
        }
      }).catch(error => {
        Setting.showResponseMessage(error);
      });
  };

  const handleConfirm = () => {
    if (exportType === 2 && transferedNodes.length === 0) {
      Setting.showMessage("error", i18next.t("user:Please select at least one department"));
      return;
    }
    if (exportType === 1) {
      onConfirmSelect(true);
    } else {
      onConfirmSelect(false, enableDirectExport, transferedNodes);
    }
  };

  const onCheck = (checkedKeyValues, e) => {
    e.nativeEvent.stopPropagation();
    setCheckedKeys(checkedKeyValues.checked);
    if (!e.checked) {
      const list = transferedNodes.filter(item => {
        return item.uid !== e.node.uid;
      });
      setTransferedNodes(list);
      clearTreeDisabled(e.node.children);
    } else {
      const index = checkedKeyValues.checked.findIndex(uid => {
        return uid === e.node.uid;
      });
      transferedNodes.splice(index, 0, e.node);
      if (enableDirectExport) {
        setTransferedNodes(transferedNodes);
      } else {
        const keys = [...checkedKeyValues.checked];
        const nodes = [...transferedNodes];
        setTreeNodeDisabled(e.node.children, keys, nodes, true);
        setCheckedKeys(keys);
        setTransferedNodes(nodes);
      }
    }
  };

  const onExpand = (expandedKeyValues, e) => {
    e.nativeEvent.stopPropagation();
    setExpandedKeys(expandedKeyValues);
  };

  const updateTreeData = (list, key, children) =>
    list.map((node) => {
      if (node.uid === key) {
        return {...node, children};
      }
      if (node.children) {
        return {...node, children: updateTreeData(node.children, key, children)};
      }

      return node;
    });

  const onLoadData = (treeNode) => {
    return new Promise((resolve) => {
      if (treeNode.children) {
        resolve();
        return;
      }

      OrganizationBackend.getDepartments(Setting.Admin, treeNode?.isOrganization ? treeNode.uid : treeNode.organId, treeNode?.isOrganization ? "0" : treeNode.uid)
        .then((res) => {
          if (res.msg === undefined) {
            const treeList = res.reverse();
            treeList.map((item, index) => {
              item.level = treeNode.level + 1;
              item.isLeaf = item.childNum === 0;
              item.icon = <IconFont.OrganizationIcon style={{fontSize: 16}} />;
            });
            if (!enableDirectExport) {
              const foundIndex = checkedKeys.findIndex(key => treeNode.uid === key);
              if (foundIndex !== -1 || treeNode.disabled && !treeNode?.isOrganization) {
                setTreeNodeDisabled(treeList, checkedKeys, transferedNodes, true);
              }
            }
            setTreeData((origin) =>
              updateTreeData(origin, treeNode.key, treeList)
            );
          } else {
            Setting.showResponseMessage(res.msg);
          }
          resolve();
        });
    });
  };

  const setTreeNodeDisabled = (list, keys, nodes, disabled = false) => {
    if (list) {
      list.map(node => {
        const foundIndex = keys.findIndex(key => node.uid === key);
        if (foundIndex !== -1) {
          keys.splice(foundIndex, 1);
        }
        const foundNode = nodes.findIndex(item => item.uid === node.uid);
        if (foundNode !== -1) {
          nodes.splice(foundNode, 1);
        }
        node.disabled = disabled;
        setTreeNodeDisabled(node.children, keys, nodes, disabled);
        return node;
      });
    }

    return list;
  };

  const clearTreeDisabled = (list) => {
    if (list) {
      list.map(node => {
        node.disabled = false;
        clearTreeDisabled(node.children);
        return node;
      });
    }
  };

  const onClickRemove = (data) => {
    const list = transferedNodes.filter(item => {
      return item.uid !== data.uid;
    });
    setTransferedNodes(list);
    setCheckedKeys(list.map(item => item.uid));
  };

  const onSearchKey = (value) => {
    setKeyword(value);
    if (keyword !== "" && value === "") {
      setSearchList([]);
      fetchTreeData();
    } else if (value !== "") {
      OrganizationBackend.getNodes(Setting.Admin, value)
        .then(res => {
          if (res.msg === undefined) {
            const list = res.map(item => {
              item.disabled = item.uid === organId ? true : false;
              return item;
            });
            setSearchList(list);
            setTreeData([]);
          } else {
            Setting.showResponseMessage(res.msg);
          }
        });
    }
  };

  const onSearchCheck = (e, node) => {
    if (!e.target.checked) {
      const list = transferedNodes.filter(item => {
        return item.uid !== node.uid;
      });
      setTransferedNodes(list);
      const checkList = checkedKeys.filter(item => item !== node.uid);
      setCheckedKeys(checkList);
    } else {
      const checkList = checkedKeys.map(item => item);
      const transferedList = transferedNodes.map(item => item);
      checkList.push(node.uid);
      transferedList.push(node);
      setCheckedKeys(checkList);
      setTransferedNodes(transferedList);
    }
  };

  return <Row>
    <Modal
      className="modal-import-user"
      maskClosable={false}
      destroyOnClose={true}
      title={i18next.t("user:Export user")}
      visible={visible}
      okText={i18next.t("general:Confirm")}
      cancelText={i18next.t("general:Cancel")}
      confirmLoading={confirmLoading}
      onCancel={() => {dismiss();}}
      onOk={handleConfirm}
      width={704}
    >
      <Row style={{marginTop: 20, marginBottom: 20, width: 620, marginLeft: "calc(50% - 310px)"}}>
        <Radio.Group onChange={(e) => setExportType(e.target.value)} value={exportType}>
          <Radio value={1}>{i18next.t("user:All user")}</Radio>
          <Radio value={2}>{i18next.t("user:Partial user")}</Radio>
        </Radio.Group>
        {
          exportType === 2 ?
            <>
              <span style={{marginRight: 10}}>{i18next.t("user:Only export users directly in this department")}</span>
              <Switch
                checked={enableDirectExport}
                onChange={checked => {
                  setEnableDirectExport(checked);
                  setCheckedKeys([]);
                  setTransferedNodes([]);
                  treeData.map(treeNode => {
                    clearTreeDisabled(treeNode.children);
                  });
                }} />
            </>
            :
            null
        }
      </Row>
      {
        exportType === 2 ?
          <Row style={{marginBottom: "20px"}} justify="center">
            <div style={{width: "295px"}}>
              <div style={{width: "100%", height: "330px", overflow: "auto", borderStyle: "solid", borderColor: "#DDDDDD", borderWidth: "1px"}}>
                <Input.Search
                  style={{
                    marginTop: 20,
                    marginBottom: 8,
                    marginLeft: 20,
                    width: "85%",
                  }}
                  allowClear={true}
                  placeholder={i18next.t("organization:Please input organzation or department name")}
                  onSearch={(value) => {
                    onSearchKey(value);
                  }}
                />
                {
                  keyword === "" ?
                    <Tree
                      className="user-transfer-tree"
                      showIcon={true}
                      checkable={true}
                      checkStrictly={true}
                      onExpand={onExpand}
                      expandedKeys={expandedKeys}
                      onCheck={onCheck}
                      checkedKeys={checkedKeys}
                      selectable={false}
                      switcherIcon={<DownOutlined />}
                      fieldNames={{title: "displayName", key: "uid", children: "children"}}
                      titleRender={(node) => {
                        return (
                          <span className={`user-transfer-tree-node-title ${titleNodeName}-${node.level}`}>{node.displayName}</span>
                        );
                      }}
                      treeData={treeData}
                      loadData={onLoadData}
                    />
                    :
                    <List
                      className="user-transfer-search-list"
                      size="small"
                      split={false}
                      dataSource={searchList}
                      renderItem={item => {
                        const checked = transferedNodes.findIndex(node => item.uid === node.uid) !== -1 ? true : false;
                        return <List.Item style={{width: "100%"}}
                        >
                          <IconFont.OrganizationIcon style={{marginLeft: "5px", marginRight: "5px", color: "#333333", fontSize: 16}} />
                          <Checkbox
                            disabled={item.disabled}
                            checked={checked}
                            onChange={(e) => {
                              onSearchCheck(e, item);
                            }}
                          >
                          </Checkbox>
                          <span style={{width: "calc(100% - 24px - 32px)", display: "inline-block", overflow: "hidden",
                            whiteSpace: "nowrap", textOverflow: "ellipsis", textAlign: "left", color: "#333333"}}>{item.displayWholeName}</span>
                        </List.Item>;
                      }}
                    />
                }
              </div>
            </div>
            <Row align="middle" justify="center" style={{width: "30px"}}>
              <IconFont.ArrowFillingRightIcon style={{color: "#BBBBBB", fontSize: 24}} />
            </Row>
            <div style={{width: "295px"}}>
              <div style={{width: "100%", height: "330px", overflowY: "auto", borderStyle: "solid", borderColor: "#DDDDDD", borderWidth: "1px"}}>
                <List
                  className="user-tansfer-list"
                  size="small"
                  split={false}
                  dataSource={transferedNodes}
                  renderItem={item => <List.Item style={{width: "100%"}}>
                    <IconFont.OrganizationIcon style={{marginLeft: "5px", marginRight: "5px", color: "#333333", fontSize: 16}} />
                    <span style={{width: "calc(100% - 24px - 32px)", display: "inline-block", overflow: "hidden",
                      whiteSpace: "nowrap", textOverflow: "ellipsis"}}>{item.displayName}</span>
                    <Button icon={<CloseOutlined style={{font: "12px", color: "#999999"}} />} type="text" onClick={(e) => onClickRemove(item)}></Button>
                  </List.Item>}
                />
              </div>
            </div>
          </Row>
          :
          null
      }
    </Modal>
  </Row>;
};

export default UserExportModal;
